import React, { Fragment, useState } from "react";
import Popover from "@mui/material/Popover";

import { Typography } from "../../typo-components";
import { Flex } from "../../container-components";

const P = (props) => {
  const {
    text,
    content,
    style,
    anchorOrigin,
    isClick,
    id,
    margin,
    typographyProps,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const typographyStyle = typographyProps?.style ? typographyProps.style : {};
  const color = typographyProps?.color || "primary";

  return (
    <Fragment>
      <Typography
        onClick={handleClick}
        onMouseEnter={handleClick}
        onMouseLeave={handleClose}
        variant="t6"
        color={color}
        margin={margin || "0"}
        style={{ cursor: "pointer", ...typographyStyle }}
      >
        {text}
      </Typography>

      <Popover
        id={id || "mouse-over-popover"}
        open={open}
        style={{
          pointerEvents: isClick ? "auto" : "none",
          margin: "3px 0 5px 0",
          ...style,
        }}
        anchorEl={anchorEl}
        anchorOrigin={
          anchorOrigin || {
            vertical: "center",
            horizontal: "center",
          }
        }
        onClose={handleClose}
        disableRestoreFocus
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Flex>
          <Flex id="popover-content" style={{ padding: "20px 30px" }}>
            {typeof content === "function" ? content() : content}
          </Flex>
        </Flex>
      </Popover>
    </Fragment>
  );
};

export default P;
